// Cross-surface "points changed" broadcast.
//
// "My Points & Badges" is rendered by several surfaces that each hold their OWN
// useMyPoints instance — the feed (CommunityFeed/MembershipShell), the courses
// page (CourseViews), the home page, the group collection. Each keeps private
// `me`/`pts` state.
//
// That's why points looked stale until a full page reload: earning points on one
// surface refreshed only that surface's copy. Upload a profile photo from the
// modal the feed owns, switch to Courses, and the card there was still showing
// the pre-award number — its instance was never told anything happened.
//
// So a refresh now notifies every mounted instance instead of just the caller's.
// Each subscriber re-pulls with force:true, bypassing the 8s response cache.

const subscribers = new Set();

/** Subscribe to point changes. Returns the unsubscribe function. */
export function onPointsChanged(fn) {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
}

/**
 * Announce that the signed-in member's points changed.
 *
 * @param {Function} [origin] the subscriber that triggered this, skipped so the
 *                            caller doesn't fetch twice
 */
export function emitPointsChanged(origin) {
  for (const fn of Array.from(subscribers)) {
    if (fn === origin) continue;
    try {
      fn();
    } catch {
      // One bad subscriber must never stop the others from updating.
    }
  }
}
